import React from 'react';
// Light build + JSON only: the default entry bundles every highlight.js and Prism language.
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/light';
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json';
import defaultStyle from 'react-syntax-highlighter/dist/esm/styles/hljs/default-style';
import './JsonRenderer.scss';

SyntaxHighlighter.registerLanguage('json', json);

const JsonRenderer = ({ json, title, variant = 'card' }) => {
  return (
    <div className={`json-renderer json-renderer--${variant}`}>
      <h3 className="json-renderer__title">{title}</h3>
      {json && (
        <div className="json-renderer__content">
          <SyntaxHighlighter language="json" style={defaultStyle} wrapLongLines>
            {JSON.stringify(json, null, 2)}
          </SyntaxHighlighter>
        </div>
      )}
    </div>
  );
};

export default JsonRenderer;
